// extracted by mini-css-extract-plugin
module.exports = {"root":"BabylonBackground_root__4DnJk","fadeIn":"BabylonBackground_fadeIn__1rQz1","glow":"BabylonBackground_glow__2rzsf"};